import React, { useEffect, useState } from "react";

const NumberLineImages = ({ templateNumber }) => {

    return (
        <div>
            {Array.from({ length: templateNumber }, (_, index) => (
                <img
                    key={index + 1}
                    src={`assets/img/NumLine${index + 1}.png`}
                    alt={`number-show-default-${index + 1}`}
                    className={`img-fluid number-show number-show${index + 1} ${index + 1 === 1 ? "active" : " "} `}
                />
            ))}
        </div>
    );
};

export default NumberLineImages;
